import { NgModule } from '@angular/core';
import { DateFormatService } from './date-format.service';

@NgModule({
  providers: [
    DateFormatService,
  ],
})
export class DateFormatModule {
}
